import dialogPolyfill from 'dialog-polyfill';

const dialog = document.querySelector('dialog');
dialogPolyfill.registerDialog(dialog);

if( !localStorage.getItem('hasSeenWelcomeModal')) {
  dialog.showModal();
}